import type { LandscapeImmersive } from '@/types';

interface LandscapeImmersiveProps {
  layout: LandscapeImmersive;
}

/**
 * This block used to open a mirrored cylinder over the page. That scene is retired: a work's
 * room now comes from its Room tab and opens at the work's own address, and the entry's page
 * shows the room in its stage. An entry that still carries the block shows nothing for it.
 */
export const Landscape_Immersive = (_props: LandscapeImmersiveProps) => null;
